module.exports = __webpack_public_path__ + "static/media/circular-stairs.f3853f4f.jpg";